(function rebuyCartUpsell() {
  const ROOT_SELECTOR = '[data-rebuy-upsell]';
  const SLIDER_SELECTOR = '[data-rebuy-upsell-slider]';
  const SKELETON_SELECTOR = '[data-rebuy-upsell-skeleton]';
  const CARD_SELECTOR = '[data-upsell-holder]';
  const COLLAPSIBLE_TRIGGER_SELECTOR = '[data-collapsible-trigger]';
  const COLLAPSIBLE_CONTAINER_SELECTOR = '[data-collapsible-container]';
  const COLLAPSIBLE_CONTENT_SELECTOR = '[data-collapsible-content]';
  const EXPANDED_CLASS = 'is-expanded';
  const COLLAPSIBLE_ANIMATION_DELAY = 500;
  const rootStateMap = new WeakMap();
  const timerMap = new WeakMap();
  const DISABLE_FLAG = 'disableCartUpsellRebuy';

  function getRootState(root) {
    if (!rootStateMap.has(root)) {
      rootStateMap.set(root, {
        collapsibleInitialized: false,
        collapsibleHandler: null,
        flkty: null,
        requestId: 0,
      });
    }

    return rootStateMap.get(root);
  }

  function getTimer(element) {
    return timerMap.get(element);
  }

  function setTimer(element, timerId) {
    timerMap.set(element, timerId);
  }

  function clearElementTimer(element) {
    const timerId = getTimer(element);
    if (timerId) clearTimeout(timerId);
  }

  function setElementHidden(element, isHidden) {
    const node = element;
    node.hidden = isHidden;
  }

  function setElementDisabled(element, isDisabled) {
    const node = element;
    node.disabled = isDisabled;
  }

  function setElementHeight(element, value) {
    const node = element;
    node.style.height = value;
  }

  function safeDestroyFlickity(instance) {
    if (!instance || typeof instance.destroy !== 'function') return;

    try {
      instance.destroy();
    } catch {
      // Ignore Flickity destroy failures for detached nodes.
    }
  }

  function getFlickityLib() {
    return (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
  }

  function destroySliderInstance(slider, rootState) {
    const FlickityLib = getFlickityLib();
    const sliderInstance = FlickityLib && typeof FlickityLib.data === 'function' ? FlickityLib.data(slider) : null;
    const state = rootState;

    safeDestroyFlickity(sliderInstance);
    safeDestroyFlickity(state.flkty);

    state.flkty = null;

    if (window.cart && window.cart.pairProducts === slider) {
      window.cart.flktyUpsell = null;
    }
  }

  function bindQuickView(root) {
    const QuickViewPopup = window.themeQuickViewPopup;
    const cartDrawer = root.closest('[data-cart-drawer]');
    const container = cartDrawer || document;

    if (typeof QuickViewPopup === 'function') {
      return new QuickViewPopup(container);
    }

    return null;
  }

  function getApiKey(root) {
    const rebuyGlobal = window.Rebuy || {};
    const rebuyConfig = rebuyGlobal.config || rebuyGlobal.Config || {};
    const candidates = [root.dataset.rebuyApiKey, rebuyConfig.api_key, rebuyConfig.apiKey].filter(Boolean);
    return candidates[0] || '';
  }

  function isUpsellDisabled() {
    return Boolean(window[DISABLE_FLAG]);
  }

  function normalizeOptionValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function getCartOptionPreferences(cartItems) {
    return (cartItems || []).reduce(
      (preferences, item) => {
        const colorValue = normalizeOptionValue(item && item.variant_options && item.variant_options[0]);
        const sizeValue = normalizeOptionValue(item && item.variant_options && item.variant_options[1]);

        if (colorValue) preferences.colorValues.add(colorValue);
        if (sizeValue) preferences.sizeValues.add(sizeValue);

        return preferences;
      },
      {
        colorValues: new Set(),
        sizeValues: new Set(),
      },
    );
  }

  function getCartProductIds(root) {
    const fallbackProductIds = root.dataset.shopifyProductIds || '';
    const fallbackVariantIds = root.dataset.shopifyVariantIds || '';

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load cart');
        return response.json();
      })
      .then((cart) => {
        const productIds = (cart.items || [])
          .map((item) => item.product_id)
          .filter(Boolean)
          .reduce((unique, id) => {
            if (unique.indexOf(id) === -1) unique.push(id);
            return unique;
          }, []);

        const variantIds = (cart.items || [])
          .map((item) => item.variant_id)
          .filter(Boolean)
          .reduce((unique, id) => {
            if (unique.indexOf(id) === -1) unique.push(id);
            return unique;
          }, []);

        return {
          productIds: productIds.map(String),
          variantIds: variantIds.map(String),
          optionPreferences: getCartOptionPreferences(cart.items || []),
        };
      })
      .catch(() => ({
        productIds: fallbackProductIds.split(',').filter(Boolean),
        variantIds: fallbackVariantIds.split(',').filter(Boolean),
        optionPreferences: {
          colorValues: new Set(),
          sizeValues: new Set(),
        },
      }));
  }

  function formatPrice(rawPrice, moneyFormatter) {
    const numberPrice = Number(rawPrice);
    if (!Number.isFinite(numberPrice)) return '';
    return moneyFormatter.format(numberPrice);
  }

  function getSquareShopifyImageUrl(url, size) {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      const host = (parsedUrl.hostname || '').toLowerCase();
      const isShopifyCdnHost = host.indexOf('cdn.shopify.com') > -1 || host.indexOf('shopifycdn.net') > -1;
      if (!isShopifyCdnHost) return url;

      parsedUrl.searchParams.set('width', String(size));
      parsedUrl.searchParams.set('height', String(size));
      parsedUrl.searchParams.set('crop', 'center');
      return parsedUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function findBestMatchingVariant(product, optionPreferences) {
    const variants = product && product.variants ? product.variants : [];
    const preferences = optionPreferences || { colorValues: new Set(), sizeValues: new Set() };

    if (!variants.length) return null;

    return variants.reduce((bestVariant, variant) => {
      const colorValue = normalizeOptionValue(variant.option1);
      const sizeValue = normalizeOptionValue(variant.option2);
      const colorScore = colorValue && preferences.colorValues.has(colorValue) ? 2 : 0;
      const sizeScore = sizeValue && preferences.sizeValues.has(sizeValue) ? 1 : 0;
      const score = colorScore + sizeScore;

      if (!bestVariant || score > bestVariant.score) {
        return {
          score,
          variant,
        };
      }

      return bestVariant;
    }, null).variant;
  }

  function createCard(
    product,
    cartProductIds,
    optionPreferences,
    moneyFormatter,
    rootUrl,
    quickShopLabel,
    cardTemplate,
  ) {
    const variant = findBestMatchingVariant(product, optionPreferences);
    if (!variant) return null;

    const productId = product && product.id ? String(product.id) : '';
    if (productId && cartProductIds.indexOf(productId) > -1) return null;

    const productImages = product && product.images ? product.images : [];
    const variantImageId = variant && variant.image_id ? String(variant.image_id) : '';
    const variantImage =
      variantImageId && productImages.length
        ? productImages.find((imageItem) => String(imageItem && imageItem.id) === variantImageId)
        : null;
    const primaryImage = variantImage || (product && product.image ? product.image : null);
    const fallbackImage = productImages.length ? productImages[0] : null;
    const rawImageSrc = (primaryImage && primaryImage.src) || (fallbackImage && fallbackImage.src) || '';
    const imageSrc = getSquareShopifyImageUrl(rawImageSrc, 600);
    const handle = product && product.handle ? String(product.handle) : '';
    if (!handle) return null;

    const normalizedRootUrl = rootUrl && rootUrl.slice(-1) === '/' ? rootUrl : `${rootUrl}/`;
    const variantId = variant && variant.id ? String(variant.id) : '';
    const productUrl = variantId
      ? `${normalizedRootUrl}products/${handle}?variant=${variantId}`
      : `${normalizedRootUrl}products/${handle}`;
    const title = product && product.title ? String(product.title) : '';
    const compareAt = variant.compare_at_price;
    const { price } = variant;
    const hasCompareAt = Boolean(compareAt) && Number(compareAt) > Number(price);

    if (!cardTemplate || !cardTemplate.content || !cardTemplate.content.firstElementChild) return null;

    const card = cardTemplate.content.firstElementChild.cloneNode(true);
    const imageLink = card.querySelector('[data-rebuy-image-link]');
    const image = card.querySelector('[data-rebuy-image]');
    const quickViewLink = card.querySelector('[data-rebuy-quick-view-link]');
    const quickViewText = card.querySelector('[data-rebuy-quick-view-text]');
    const titleLink = card.querySelector('[data-rebuy-title-link]');
    const priceEl = card.querySelector('[data-rebuy-price]');
    const priceNewEl = card.querySelector('[data-rebuy-price-new]');
    const priceCompareEl = card.querySelector('[data-rebuy-price-compare]');

    if (imageLink) {
      imageLink.href = productUrl;
      imageLink.setAttribute('aria-label', title);
    }

    if (image) {
      image.alt = title;
      if (imageSrc) {
        image.src = imageSrc;
      } else {
        image.remove();
      }
    }

    if (quickViewLink) {
      quickViewLink.href = productUrl;
      quickViewLink.setAttribute('aria-label', `${quickShopLabel}: ${title}`);
      quickViewLink.setAttribute('data-handle', handle);
    }

    if (quickViewText) {
      quickViewText.textContent = quickShopLabel;
    }

    if (titleLink) {
      titleLink.href = productUrl;
      titleLink.textContent = title;
    }

    if (priceEl) {
      if (hasCompareAt) {
        if (priceNewEl) {
          priceNewEl.hidden = false;
          priceNewEl.textContent = formatPrice(price, moneyFormatter);
        }
        if (priceCompareEl) {
          priceCompareEl.hidden = false;
          priceCompareEl.textContent = formatPrice(compareAt, moneyFormatter);
        }
      } else {
        priceEl.textContent = formatPrice(price, moneyFormatter);
        if (priceNewEl) priceNewEl.hidden = true;
        if (priceCompareEl) priceCompareEl.hidden = true;
      }
    }

    return card;
  }

  function getCollapsibleElements(root) {
    const trigger = root.querySelector(COLLAPSIBLE_TRIGGER_SELECTOR);
    const container = root.querySelector(COLLAPSIBLE_CONTAINER_SELECTOR);
    const content = root.querySelector(COLLAPSIBLE_CONTENT_SELECTOR);

    if (!trigger || !container || !content) return null;

    return { trigger, container, content };
  }

  function setExpandedState(elements, isExpanded) {
    const { trigger, container } = elements;
    trigger.classList.toggle(EXPANDED_CLASS, isExpanded);
    container.classList.toggle(EXPANDED_CLASS, isExpanded);
    trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    container.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  }

  function openCollapsible(elements) {
    const { trigger, container, content } = elements;
    if (trigger.disabled) return;

    setElementDisabled(trigger, true);
    setExpandedState(elements, true);
    const contentHeight = content.offsetHeight;
    setElementHeight(container, `${contentHeight}px`);

    clearElementTimer(container);
    setTimer(
      container,
      setTimeout(() => {
        setElementHeight(container, 'auto');
        setElementDisabled(trigger, false);
      }, COLLAPSIBLE_ANIMATION_DELAY),
    );
  }

  function closeCollapsible(elements) {
    const { trigger, container, content } = elements;
    if (trigger.disabled) return;

    setElementDisabled(trigger, true);
    const contentHeight = content.offsetHeight;
    setElementHeight(container, `${contentHeight}px`);

    requestAnimationFrame(() => {
      setExpandedState(elements, false);
      setElementHeight(container, '0px');
    });

    clearElementTimer(container);
    setTimer(
      container,
      setTimeout(() => {
        setElementHeight(container, '');
        setElementDisabled(trigger, false);
      }, COLLAPSIBLE_ANIMATION_DELAY),
    );
  }

  function initCollapsible(root) {
    const rootState = getRootState(root);
    const elements = getCollapsibleElements(root);
    if (!elements) return;

    // Start opened by default for this widget.
    setExpandedState(elements, true);
    setElementHeight(elements.container, 'auto');

    if (rootState.collapsibleInitialized) return;

    const onTriggerClick = (event) => {
      event.preventDefault();
      const isExpanded = elements.trigger.classList.contains(EXPANDED_CLASS);
      if (isExpanded) {
        closeCollapsible(elements);
      } else {
        openCollapsible(elements);
      }
    };

    elements.trigger.addEventListener('click', onTriggerClick);
    rootState.collapsibleInitialized = true;
    rootState.collapsibleHandler = onTriggerClick;
  }

  function initSlider(root, slider) {
    const rootState = getRootState(root);
    setElementHidden(slider, false);
    setElementHidden(root, false);
    initCollapsible(root);

    const cards = slider.querySelectorAll(CARD_SELECTOR);

    if (!cards.length) {
      setElementHidden(root, true);
      return;
    }

    bindQuickView(root);

    const FlickityLib = getFlickityLib();

    if (cards.length < 2 || !FlickityLib) return;

    rootState.flkty = new FlickityLib(slider, {
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'left',
      wrapAround: false,
      groupCells: true,
      contain: true,
    });
  }

  function hasRenderedCards(slider) {
    return slider.querySelectorAll(CARD_SELECTOR).length > 0;
  }

  function isWidgetInitialized(root) {
    const rootState = getRootState(root);
    return rootState.requestId > 0;
  }

  function setLoadingState(root, isLoading) {
    const slider = root.querySelector(SLIDER_SELECTOR);
    const skeleton = root.querySelector(SKELETON_SELECTOR);
    const hasCards = slider && hasRenderedCards(slider);

    if (skeleton) {
      setElementHidden(skeleton, !isLoading || hasCards);
    }

    if (slider) {
      setElementHidden(slider, isLoading && !hasCards);
    }

    if (isLoading) {
      setElementHidden(root, false);
      initCollapsible(root);
    }
  }

  function resizeExistingSliders() {
    if (isUpsellDisabled()) return;

    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const rootState = getRootState(root);
      const slider = root.querySelector(SLIDER_SELECTOR);
      if (!slider || !hasRenderedCards(slider)) return;

      if (rootState.flkty && typeof rootState.flkty.resize === 'function') {
        requestAnimationFrame(() => rootState.flkty.resize());
      } else if (window.cart && window.cart.flktyUpsell && typeof window.cart.flktyUpsell.resize === 'function') {
        requestAnimationFrame(() => window.cart.flktyUpsell.resize());
      }
    });
  }

  function loadRecommendations(root) {
    const rootState = getRootState(root);
    const slider = root.querySelector(SLIDER_SELECTOR);
    if (!slider) return;

    if (isUpsellDisabled()) {
      setLoadingState(root, false);
      setElementHidden(root, true);
      return;
    }

    const shouldShowSkeleton = !hasRenderedCards(slider);

    const apiKey = getApiKey(root);
    const endpoint = root.dataset.rebuyEndpoint;
    if (!apiKey || !endpoint) {
      setLoadingState(root, false);
      setElementHidden(root, true);
      return;
    }

    const requestId = rootState.requestId + 1;
    rootState.requestId = requestId;
    const isStale = () => rootState.requestId !== requestId || !root.isConnected;

    if (shouldShowSkeleton) {
      setLoadingState(root, true);
    }

    const currencyCode = root.dataset.currencyCode || 'USD';
    const sectionRootUrl = root.dataset.rootUrl || '/';
    const limit = Number(root.dataset.limit || 8);
    const quickShopLabel = root.dataset.quickViewLabel || 'Quick shop';
    const cardTemplate = root.querySelector('[data-rebuy-upsell-card-template]');
    const currencyLocale = document.documentElement.lang || undefined;

    const moneyFormatter = new Intl.NumberFormat(currencyLocale, {
      style: 'currency',
      currency: currencyCode,
    });

    getCartProductIds(root)
      .then(({ productIds: cartProductIds, variantIds: cartVariantIds, optionPreferences }) => {
        if (isStale()) return;

        if (!cartProductIds.length) {
          setLoadingState(root, false);
          if (!hasRenderedCards(slider)) setElementHidden(root, true);
          return;
        }

        const params = new URLSearchParams({
          key: apiKey,
          limit: String(limit),
          shopify_product_ids: cartProductIds.join(','),
          shopify_variant_ids: cartVariantIds.join(','),
        });

        fetch(`${endpoint}?${params.toString()}`)
          .then((response) => {
            if (!response.ok) throw new Error(`Rebuy request failed (${response.status})`);
            return response.json();
          })
          .then((result) => {
            if (isStale()) return;

            const products = Array.isArray(result && result.data) ? result.data : [];
            const cardElements = products
              .map((product) =>
                createCard(
                  product,
                  cartProductIds,
                  optionPreferences,
                  moneyFormatter,
                  sectionRootUrl,
                  quickShopLabel,
                  cardTemplate,
                ),
              )
              .filter(Boolean);

            if (!cardElements.length) {
              setLoadingState(root, false);
              if (!hasRenderedCards(slider)) setElementHidden(root, true);
              return;
            }

            const fragment = document.createDocumentFragment();
            cardElements.forEach((card) => fragment.appendChild(card));
            destroySliderInstance(slider, rootState);
            slider.replaceChildren(fragment);
            setLoadingState(root, false);
            initSlider(root, slider);
          });
      })
      .catch(() => {
        if (isStale()) return;
        setLoadingState(root, false);
        if (!hasRenderedCards(slider)) setElementHidden(root, true);
      });
  }

  function refreshAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      loadRecommendations(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  document.addEventListener('theme:cart:loaded', refreshAll);
  document.addEventListener('theme:cart:added', refreshAll);
  document.addEventListener('theme:cart:update', refreshAll);
  document.addEventListener('theme:cart:open', () => {
    const hasUninitializedWidget = Array.from(document.querySelectorAll(ROOT_SELECTOR)).some(
      (root) => !isWidgetInitialized(root),
    );

    if (hasUninitializedWidget) {
      refreshAll();
      return;
    }

    requestAnimationFrame(() => {
      resizeExistingSliders();
    });

    setTimeout(() => {
      resizeExistingSliders();
    }, 350);
  });
})();
